import React from 'react';
import { useDataroomListingContext } from "../../../contexts/DataroomListingContext";
import { IDataroomListItem } from "../../../domain/vo/DataroomListItem";
import AllowedActions from '../AllowedActions';
import { ICellProps } from '@dealroadshow/uikit-table/DataTable';
import { useDataroomAvailabilityContext } from '../../../contexts/DataroomAvailabilityContext';

interface IProps {
  cellProps: ICellProps<IDataroomListItem>,
}

const Actions = ({ cellProps }: IProps) => {
  const { getCollection } = useDataroomListingContext();
  const { isDisabled } = useDataroomAvailabilityContext();

  return (
    <AllowedActions
      cellProps={ cellProps }
      onSuccessUnfollowCallback={ getCollection }
      isRestricted={ isDisabled(cellProps) }
    />
  );
};

export default Actions;
